/* eslint-disable no-secrets/no-secrets */
/* eslint-disable padding-line-between-statements */
import React, { useCallback, useContext, useState, useEffect, useMemo } from 'react';
import { BreakpointTrackerContext } from '@jutro/layout';
import _ from 'lodash';
import {  useTranslator } from '@jutro/locale';
import { Loader, useModal } from '@jutro/components';
import CustomLoader from 'producer-engage/src/components/CustomLoader/CustomLoader';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { GatewayEndorsementService as LoadSaveService } from 'twia-capability-gateway-policychange';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import wizardStyles from 'twia-portals-wizard-components-ui/common/TWIAWizard.module.scss';
import { TWIAPhoneComponent, TWIAAddressComponent, TWIAEmailComponent } from 'twia-capability-address-component';
import addressControl from 'twia-capability-address-component/util/addressControl';
import { AddressStandardizationService } from 'twia-capability-addressstandardization';
// const [validationMessages, setValidationMessages] = useState([]);
import ErrorPopupUtil from 'ent-components-platform-react/util/ErrorPopupUtil';
// import PrintDocumentUtil from 'ent-capability-quoteandbind-common-react/util/PrintDocumentUtil.js';
import { CustomQuoteService } from 'twia-capability-quoteandbind-residential';
import PrintDocumentUtils from 'ent-capability-quoteandbind-common-react/util/PrintDocumentUtils.js';
import PrintDocumentConfirmationPopup from 'ent-capability-quoteandbind-common-react/pages/PrintDocument/PrintDocumentConfirmationPopup';
import PrintDocumentErrorPopup from 'ent-capability-quoteandbind-common-react/pages/PrintDocument/PrintDocumentErrorPopup';
import TWIAPolicySummary from 'twia-capability-quoteandbind-cp-react/components/TWIAPolicySummary/TWIAPolicySummary';
import { resetElectronicPaymentData } from 'ent-capability-quoteandbind-common-react/util/ResetElectronicData';
import StandardAddressValidationUtil from 'twia-capability-address-component/util/StandardAddressValidationUtil';
import styles from './CoverageSummaryPage.module.scss';
import metadata from './CoverageSummaryPage.metadata.json5';

function CoverageSummaryPage(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { wizardData: submissionVM, updateWizardData, onResolve, onAfterClose } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [isPrinting, setIsPrinting] = useState(false);
    const [accountHolderVM, setAccountHolderVM] = useState(submissionVM.baseData.accountHolder);
    const [addressVM, setAddressVM] = useState(submissionVM.baseData.accountHolder.primaryAddress);
    const [showErrors, setShowErrors] = useState(false);
    const { authHeader } = useAuthentication();
    const translator = useTranslator();
    const { showAlert, showConfirm, showModal } = useModal();
    const country = _.get(accountHolderVM, 'primaryAddress.country.value.code');
    const isPerson = _.get(submissionVM, 'baseData.accountHolder.subtype.value') === 'Person';
    const [invalidComponent, setInvalidComponents] = useState([]);
    const { isComponentValid, initialValidation, onValidate } = useValidation('CoverageSummaryPage');
    const selectedUWCompany = _.get(submissionVM, 'baseData.associationName_TWIA.value.code');
    const [isButtonDisabled, updateDisablity] = useState(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [pcConstants, setPCConstants] = useState([]);
    const [isStandardizationDisabled, setIsStandardizationDisabled] = useState(false);
    const [isAddressEdited, setIsAddressEdited] = useState(false);
    const [validatingEmail, setValidatingEmail] = useState(false);
    const xPortal = 'PE';
    const ceUserName = _.get(submissionVM, 'baseData.accountHolder.registeredCEUsername_TWIA.value');
    const autoPayEnabled = _.get(submissionVM, 'baseData.accountHolder.isAutoPayEnabled_TWIA.value');

    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'CoverageSummaryPage');
        }
    }, [isComponentValid, onValidate]);

    const findInvalidComponent = useCallback((isValid, componentID) => {
        if (isValid === false) {
            setInvalidComponents((oldValue) => [...oldValue, componentID]);
        }

        if (isValid === true) {
            setInvalidComponents((oldValue) => oldValue.filter((val) => val !== componentID));
        }
    }, []);

    // US26285
    // const quotePrintDocument = useCallback(async () => {
    //     // setIsPrinting(true);
    //     await PrintDocumentUtil.printDocument(submissionVM, showConfirm, showAlert, translator, authHeader, setIsPrinting);
    // }, [authHeader, showAlert, showConfirm, submissionVM, translator]);

    const quotePrintDocument = useCallback(() => {
        const {getPublicID, getPath, getQuoteStatus} = PrintDocumentUtils(submissionVM);
        setIsPrinting(true);
        
        const publicID = getPublicID();
        const docPath = getPath();
        const quoteStatus = getQuoteStatus();       
        const componentProps = { submissionVM, setIsPrinting, isOpen: true, onResolve, onAfterClose, docPath, quoteStatus};       
        if (quoteStatus === 'Quoted' || quoteStatus === 'Submitted_Ext' || quoteStatus === 'Renewing') {
            CustomQuoteService.generateDocument_TWIA(publicID, 'quoteSummary', authHeader).then(() => {
                showModal(<PrintDocumentConfirmationPopup {...componentProps} />);
            });
        }  else {
            showModal(<PrintDocumentErrorPopup {...componentProps} />);
        }
    }, [authHeader, onAfterClose, onResolve, showModal, submissionVM])

    const getPCConstants = useCallback(async () => {
        const constants = await AddressStandardizationService.getPCPortalConstants(authHeader);
        if (constants.addressStandardizationDisabled) {
            setIsStandardizationDisabled(true);
            updateDisablity(true);
        }
        setPCConstants(constants);
    }, [authHeader]);

    useEffect(() => {
        setAccountHolderVM(submissionVM.baseData.accountHolder);
        setAddressVM(submissionVM.baseData.accountHolder.primaryAddress);
        getPCConstants();
        if (submissionVM.baseData.accountHolder.primaryAddress?.isOverridden_Ext?.value
            && !submissionVM.baseData.accountHolder.primaryAddress?.isOverriddenInternally_Ext?.value) {
            StandardAddressValidationUtil.setNotValidated(submissionVM.baseData.accountHolder.primaryAddress.value);
            setIsAddressEdited(true);  //DE18415
        }
    }, []);

    const onNext = useCallback(async () => {
        if (invalidComponent.length > 0) {
            setShowErrors(true)
            return false;
        }
        try {
            resetElectronicPaymentData(submissionVM, updateWizardData);
            // _.set(submissionVM.value, 'bindData.isAutoPayEnabled_TWIA', false);
            submissionVM.value = await LoadSaveService.saveQuotedEndorsementWithPaymentData_TWIA(
                submissionVM.value,
                authHeader
            );

            // setIsAddressEdited(false);
            return submissionVM;
        } catch (error) {
            setShowErrors(false);
            ErrorPopupUtil.showSaveErrorPopup(showAlert, true)
            return false;
        }
        
    }, [authHeader, invalidComponent, showAlert, submissionVM, updateWizardData]);

    const setDisablity = useCallback((value) => {
        if (isStandardizationDisabled) {
            updateDisablity(false);
        }
        else {
            updateDisablity(addressControl.isStdBtnAvailable(value, xPortal))
        }
    }, [isStandardizationDisabled]);

    const updateSubmissionVM = useCallback((value) => {
        setAccountHolderVM(value);
        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData]);

    const updatePolicyAddressVM = useCallback((value) => {
        _.set(submissionVM, 'baseData.accountHolder.primaryAddress', value);
        _.set(submissionVM, 'baseData.policyAddress.value', value);
        submissionVM.baseData.policyContactDetails_TWIA.children[0].primaryAddress = value;
        setDisablity(value);
        if (value.isValidated_Ext === true || value.isOverridden_Ext === true) {
            setIsAddressEdited(false);
        }
        updateWizardData(submissionVM);
    }, [setDisablity, submissionVM, updateWizardData]);


    const handleAddressEditing = useCallback((val) => {
        setIsAddressEdited(val);
    }, []);



    const overrideProps = {
        '@field': {
            // apply to all fields
            showOptional: false,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        emailAddressComponent: {
            accountHolderVM, updateSubmissionVM, authHeader, showErrors, findInvalidComponent, onValidate, ceUserName, autoPayEnabled,
            companyType: selectedUWCompany, setValidatingEmail
        },
        mailingAddressComponent: {
            addressVM, updatePolicyAddressVM, country, showErrors, findInvalidComponent, onValidate,
            companyType: selectedUWCompany,
            isStandardizationDisabled,
            onAddressEdit: handleAddressEditing,
            xPortal
        },
        phoneNumberComponent: {
            accountHolderVM, updateSubmissionVM, isPerson, showErrors, findInvalidComponent, onValidate
        },
        policySummary: {
            submissionVM,
            isQuotePage: false
        },
        editIcon: {
            disabled: (isButtonDisabled || isAddressEdited) || invalidComponent.length > 0
        },
        quotePagePrint: {
            visible : !isPrinting
        },
        cLoader: {
            visible: isPrinting
        }
    };
    const resolvers = {
        resolveCallbackMap: {
            quotePrintDocument
        },
        resolveClassNameMap: { wizardStyles, styles },
        resolveComponentMap: {
            phoneComponent: TWIAPhoneComponent,
            emailComponent: TWIAEmailComponent,
            addressComponent: TWIAAddressComponent,
            TWIAPolicySummary,
            customLoader: CustomLoader
        }
    }

    return (
        <WizardPage
            onNext={onNext}
            skipWhen={initialValidation}
            disableNext={isButtonDisabled || isAddressEdited || validatingEmail}
            disablePrevious={validatingEmail}
        >
            <Loader loaded={!isLoading}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={submissionVM}
                    showErrors={showErrors}
                    overrideProps={overrideProps}
                    onModelChange={updateWizardData}
                    onValidationChange={onValidate}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                />
            </Loader>
        </WizardPage>
    );
}

CoverageSummaryPage.propTypes = wizardProps;
export default CoverageSummaryPage